import { Component } from '@angular/core';

@Component({
  selector: 'app-less-deposit-information',
  templateUrl: './less-deposit-information.component.html',
  styleUrls: ['./less-deposit-information.component.scss'],
})
export class LessDepositInformationComponent {}
